
import TableList from "@components/templates/tablelist";
import { HttpGetSalesmanList,HttpCancelSalesmanOne,HttpActiveSalesmanOne } from "@/service/manage/manage";

import comIndex from './update'
export default {
    mixins: [TableList],
    components: {
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
        };
    },
    methods: {
        ajaxRequest: HttpGetSalesmanList,
        interceptRequest(params){
            // console.log(params)
            delete params.search.createdAt;
            delete params.search.updatedAt;
            return params;
        },
        // 全部按钮点击操作
        handleOperates(params="", type,batch) {
            if(batch){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'salesmanupdate',
                        params: { type: "add" },
                        query: { id: params },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'salesmanupdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "query":
                    this.operate = {
                        title:this.$t('global.common.query',{defaultValue:'查看'}),
                        show:true,
                        width:1200,
                        showFooter:false,
                        component: "comIndex",
                        activeids:params,
                        querytype:'query'
                    }
                    break;
                case "queryBlank":
                    var url=this.$router.resolve({
                        name: "salesmanupdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "disable":
                    this.operate={
                        show: true,
                        alert: "error",
                        params:{id:params},
                        title: this.$t('erp.b2border.stopping',{defaultValue:'停用操作'}),
                        ajaxRequest:HttpCancelSalesmanOne
                    }
                    break;
                case "active":
                    this.operate={
                        show: true,
                        alert: "error",
                        params:{id:params},
                        title: this.$tc("global.common.activeing",1,{defaultValue:'启用操作'}),
                        ajaxRequest:HttpActiveSalesmanOne
                    }
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/Salesperson/export',this.formData,'download');
                    break;

            }
        },
        // 操作下的列表展示内容
        getOperateNodeMap(row){
            const { id, active } = row
            return [{
                label:this.$t('global.common.query',{defaultValue:'查看'}),
                show:true,
                params:id,
                operate:'query'
            },{
                label:this.$t('global.common.edit',{defaultValue:'编辑'}),
                show:true,
                params:id,
                operate:'edit'
            },{
                label:this.$tc("global.common.inactive",2,{defaultValue:'停用'}),
                show:active=='Y',
                params:id,
                operate:'disable'
            },{
                label:this.$tc("global.common.activeing",2,{defaultValue:'启用'}),
                show:active=='N',
                params:id,
                operate:'active'
            }]
        },
        dedupe(array) {
			var temp = []; //一个新的临时数组
			for(var i = 0; i < array.length; i++){
				if(temp.indexOf(array[i]) == -1){
					temp.push(array[i]);
				}
			}
			return temp;
		},
    },
    computed: {
        // 左边的批量操作按钮
        ToolsData(){
            return [
                {
                    name: this.$t("global.common.add",{defaultValue:'添加'}),
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: this.$t("global.common.condition_export",{defaultValue:'查询条件导出'}),
                    operate: "export",
                    theme: "success",
                    // batch:true,
                },
            ]
        },
        // 搜索下拉框展示内容
        SearchsData() {
            return  [
                {
                    label: this.$t("erp.b2border.salesmanId",{defaultValue:'销售员ID'}),
                    tag: 'vInput',
                    key: 'EQ_id',
                    show:true,
                    formItem:{
                        labelWidth:164,
                    }
                },
                {
                    label: this.$t("erp.b2border.salesmanName",{defaultValue:'销售员姓名'}),
                    tag: 'vInput',
                    key: 'CN_fullName',
                    show:true,
                    formItem:{
                        labelWidth:164,
                    }
                },
                {
                    label: this.$t("global.common.email",{defaultValue:'邮箱'}),
                    tag: 'vInput',
                    key: 'CN_email',
                    show:true,
                    formItem:{
                        labelWidth:164,
                    }
                },

                {
                    label: this.$t("global.common.isinactive",{defaultValue:'是否停用'}),
                    tag: 'vSelect',
                    key: 'EQ_active',
                    options: [
                        {
                            value: 'N',
                            label: this.$t("erp.global.yes",{defaultValue:'是'})
                        },
                        {
                            value: 'Y',
                            label: this.$t("erp.global.no",{defaultValue:'否'})
                        },
                    ],
                    props:{
                        filterable:true,
                    }
                },

                {
                    label: this.$t("global.common.createdtime",{defaultValue:'创建时间'}),
                    tag: 'DatePicker',
                    key:'createdAt',
                    props:{
                        type:"daterange",
                        format:'yyyy-MM-dd',
                        confirm:false,
                    },
                    style: "width:180px",
                    on:{
                        'on-change':(val1)=>{
                            if(val1[0]!==''){
                                this.formData.search.BT_createdAt = val1[0] + ' ~ ' + val1[1]
                            }else{
                                this.formData.search.BT_createdAt = ''
                            }
                        },
                    }
                },
                {
                    label: this.$t("global.common.update_time",{defaultValue:'更新时间'}),
                    tag: 'DatePicker',
                    key:'updatedAt',
                    props:{
                        type:"daterange",
                        format:'yyyy-MM-dd',
                        confirm:false,
                    },
                    style: "width:180px",
                    on:{
                        'on-change':(val2)=>{
                            if(val2[0]!==''){
                                this.formData.search.BT_updatedAt = val2[0] + ' ~ ' + val2[1]
                            }else{
                                this.formData.search.BT_updatedAt = ''
                            }
                        },
                    }
                },

            ]
        },
        // table的展示数据
        columns() {
            return  [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            },{
                title: this.$t("global.common.operation",{defaultValue:'操作'}),
                width: 90,
                render:this.getOperateNodes
            },
            {
                title: this.$t("erp.b2border.salesmanid_name",{defaultValue:'销售员ID/姓名'}),
                // key: 'lineId',
                render:(h,{row})=>{
                    return <div>
                        <div>
                            <div><a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.id}</a></div>
                            <div>{row.fullName}</div>
                        </div>
                    </div>
                }
            },

            {
                title: this.$t("global.common.isinactive",{defaultValue:'是否停用'}),
                key: 'active',
                render:(h,{row})=>{
                    switch(row.active){
                        case 'N' :return <div>{this.$t("erp.global.yes",{defaultValue:'是'})}</div>; break;
                        case 'Y' :return <div>{this.$t("erp.global.no",{defaultValue:'否'})}</div>; break;
                    }

                }
            },
            {
                title: this.$t("global.common.email",{defaultValue:'邮箱'}),
                // key: 'warehouseCode',
                render:(h,{row})=>{
                    return <div>{row.email}</div>
                }
            },
            {
                title: this.$t("erp.b2c.channel_account",{defaultValue:'渠道账号'}),
                render:(h,{row})=>{
                    return <div>{row.channels || '--'}</div>
                }
            },
            {
                title: this.$t("erp.b2border.percentage",{defaultValue:'佣金百分比(%)'}),
                maxWidth:100,
                render:(h,{row})=>{
                    return <div>{row.commissionRate}</div>
                }
            },
            {
                title: this.$t("global.common.created_updated",{defaultValue:'创建/更新时间'}),
                render:(h,{row})=>{
                    return <div>
                        <div>{row.createdAt}</div>
                        <div>{row.updatedAt}</div>
                    </div>
                }
            }
        ];
        },

    },

};
